const mobileSlider = {
  homeMobileSlider() {
    const $slider = jQuery(".__onlyMobileSlider");
    const $progressBar = $slider
      .parents(".vspl__mobile_slider_model")
      .find(".__mobileSlideBar");

    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        let calc = (nextSlide / (slick.slideCount - 1)) * 100;
        $progressBar.css("width", calc + "%").attr("aria-valuenow", calc);
      }
    );

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 400,
      autoplay: true,
      centerPadding: "20px",
      autoplaySpeed: 2000,
      adaptiveHeight: true,
    });
  },
  init() {
    if (
      jQuery(window).width() < 786 &&
      jQuery(".__onlyMobileSlider").length > 0
    ) {
      this.homeMobileSlider();
    }

    jQuery(window).resize(function () {
      if (
        jQuery(window).width() < 786 &&
        jQuery(".__onlyMobileSlider").length > 0
      ) {
        this.homeMobileSlider();
      }
    });
  },
};
